import React, { Component } from 'react';
import './AddArtwork.css';

export default class AddArtwork extends Component {

	constructor(props) {
		super(props);
		this.state = {
			message : ''
		}
	}

	addArtwork = (e) => {
		e.preventDefault();
		const storageRef = this.props.base.storage().ref();
		const name = this.name.value;
		const categoryName = this.category.value;
		const medium = this.medium.value;
		const size = this.size.value;

		const FileRef = storageRef.child(`${categoryName}/${name}.jpg`);
		const StorageRef = this.props.base.database().ref(`${categoryName}/${name}`);
		
		// Put file in storage
		FileRef.put(this.file.files[0]).then(function(snapshot) {
			// Reset form
		  this.refs.addArtworkForm.reset();
		  // Success message
		  this.setState({ message: 'Artwork Uploaded!'});
			// Get download url and then add database record
		  FileRef.getDownloadURL().then(url => {
		  	StorageRef.set({
		  		name,
		  		size,
		  		medium,
		  		url,
					available: true,
					date: 0 - Date.now()
		  	});
		  });
		}.bind(this));
	}

	render() {
		return(
			<form onSubmit={this.addArtwork} ref="addArtworkForm">
				<label>Name of artwork:</label>
        <input type="text"
               ref={ (input) => this.name = input }
               placeholder="Sunset over crab island"
        />
				
				<label>Size:</label>
        <input type="text"
               ref={ (input) => this.size = input }
               placeholder="16 x 12"
        />

        <label>Medium:</label>
        <input type="text"
               ref={ (input) => this.medium = input }
               placeholder="Oil, watercolour, etc"
        />
				
				<label>Category:</label>
        <select name="category" ref={ (input) => this.category = input }>
					<option value="Landscapes">Landscapes</option>
					<option value="Marine">Marine</option>
					<option value="Misc">Misc</option>
					<option value="Urban">Urban</option>
        </select>

        <label>Artwork file:</label>
        <input type="file" 
               ref={ (input) => this.file = input }
        />

        <button type="submit">Submit</button>
        <span>{ this.state.message}</span>
			</form>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/AddArtwork.js